import React, { FC, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react'

import TcAeStripe from '@/assets/docs/tc-ae_stripe.pdf'
import TcDefault from '@/assets/docs/tc-default.pdf'
import TcItPrepaid from '@/assets/docs/tc-it_prepaid.pdf'
import { userData } from '@/redux/user/selectors'

interface Props {
  isOpen: boolean;
  onClose(): void;
}

const AmModalTermsAndConditions: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()

  const user = useSelector(userData)

  const tcFile = useMemo(() => {
    const mapping: Record<string, string> = {
      ae_stripe: TcAeStripe,
      it_prepaid: TcItPrepaid
    }

    if (!user || !user.countryCode) {
      return TcDefault
    }

    return mapping[user.countryCode] || TcDefault
  }, [user])

  // Detect iOS devices
  const isIOS = useMemo(() => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
  }, [])

  // On iOS, open PDF directly in new tab instead of showing modal
  useEffect(() => {
    if (isOpen && isIOS) {
      window.open(tcFile, '_blank', 'noopener,noreferrer')
      onClose()
    }
  }, [isOpen, isIOS, tcFile, onClose])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        maxWidth='924px'
        minHeight='700px'
        maxHeight='700px'
      >
        <ModalHeader>{t('gui.general.terms_conditions')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <iframe
            src={`${tcFile}#view=FitH`}
            style={{ width: '100%', height: '600px', border: 'none' }}
            title={t('gui.general.terms_conditions')}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AmModalTermsAndConditions
